import { Button, Col, Divider, Modal, Row, Typography, message } from "antd";
import lodash from "lodash";
import React, { useEffect, useState } from "react";
import { labelDateSelector } from "../../../store/var/var.selector";
import { createIncomeDetail } from "../../../store/income_detail/income_detail.action";
import { useDispatch, useSelector } from "react-redux";
import { detailBranchSelector } from "../../../store/branch/branch.selector";
import { updateJobById, updateJobByStaff } from "../../../store/job/job.action";
import IncomeStaffJobId from "./component/income_staff_jobId";
import IncomeStaffTime from "./component/income_staff_time";
import IncomeStaffTotal from "./component/income_staff_total";
import IncomeStaffRemaining from "./component/income_staff_remaining";
import IncomeStaffInput from "./component/income_staff_input";
import IncomeStaffIncomeList from "./component/income_staff_income_list";
import IncomeStaffServiceList from "./component/income_staff_service_list";
import { staffListSelector } from "../../../store/staff/staff.selector";
import moment from "moment";

const { Text } = Typography;
const DialogIncomeStaffInput = (props) => {
  // -------------------------- VAR --------------------------
  const {
    open,
    setOpen,
    record,
    setRecord,
    userId,
    staffList,
    incomeDetailList,
  } = props;
  // -------------------------- STATE --------------------------
  const [value, setValue] = useState(null);
  const [max, setMax] = useState(null);
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const date = useSelector(labelDateSelector);
  const userList = useSelector(staffListSelector);
  const branch = useSelector(detailBranchSelector);
  const branchId = branch ? branch?.id : "";
  // console.log(userId);
  const userIncomeList = incomeDetailList?.filter(
    (income) => income?.userId === userId
  );
  // -------------------------- FUNCTION --------------------------
  const handleCancel = () => {
    setOpen(false);
  };

  const handleAdd = () => {
    setLoading(true);
    const jobId = record?.id || "";

    // add new income in income details collection
    const data = {
      branch: branchId,
      userId,
      value,
      jobId,
      date: date,
    };
    const incomePromise = new Promise((resolve, reject) =>
      dispatch(
        createIncomeDetail({ data }, (res) => {
          if (res?.status === 200) {
            resolve(true);
            message.success("Income added successfully");
          } else {
            message.error(res?.data);
            reject(true);
            console.log(res?.data);
          }
        })
      )
    );

    // add new income in job collection
    console.log({ record });
    const update = {
      userId,
      value,
    };
    const jobPromise = new Promise((resolve, reject) => {
      if (jobId) {
        dispatch(
          updateJobByStaff(
            {
              id: jobId,
              update,
            },
            (res) => {
              if (res?.status === 200) {
                //   message.success("Added successfully");
                resolve(true);
              } else {
                message.error(res?.data);
                reject(true);
              }
            }
          )
        );
      } else {
        resolve(true);
      }
    });
    // sau khi đã record data thành công.
    Promise.all([incomePromise, jobPromise]).then(() => {
      setLoading(false);
      if (record) {
        setOpen(false);
      } else {
        setMax(null);
        setValue(null);
      }
    });
  };

  const handleAfterClose = () => {
    const update = {
      lockAt: moment().toDate(),
    };
    const id = record?.id;
    if (id) {
      dispatch(
        updateJobById({ id, update }, (res) => {
          if (res.status === 200) {
            console.log("unlocked");
            setRecord(null);
            setMax(null);
            setValue(null);
          } else {
            //
          }
        })
      );
    } else {
      setRecord(null);
      setMax(null);
      setValue(null);
    }
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (record) {
      const spent = lodash.sumBy(record?.staffs, (staff) => staff?.value);
      const remainingValue = record?.subtotal - spent;
      setValue(remainingValue);
      if (record) {
        setMax(remainingValue);
      }
    }
  }, [record]);

  // auto close modal after 1 minute
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        setOpen(false);
        message.warning("Exceeded waiting time");
      }, 60000); // Đóng modal sau 1 phút

      // Hủy bỏ hẹn giờ khi component unmount
      return () => clearTimeout(timer);
    }
  }, [open]);

  // -------------------------- RENDER --------------------------
  const renderButtonGroup = () => {
    return (
      <Col span={24}>
        <Row gutter={[10, 10]}>
          <Col span={12}>
            <Button
              type="default"
              size="large"
              block
              onClick={handleCancel}
              loading={loading}
            >
              {record ? "Cancel" : "Done"}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              size="large"
              block
              onClick={handleAdd}
              loading={loading}
            >
              Add
            </Button>
          </Col>
        </Row>
      </Col>
    );
  };
  const renderExtra = () => {
    const totalIncome =
      userIncomeList?.length > 0
        ? lodash.sumBy(userIncomeList, (item) => item?.value)
        : 0;
    const lastIncome =
      userIncomeList?.length > 0
        ? lodash.sortBy(userIncomeList, ["createAt"]).reverse()[0]?.value
        : 0;
    return (
      <>
        <Col span={24}>
          <Row justify="space-between">
            <Col>Total incomes:</Col>
            <Col>${totalIncome}</Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="space-between">
            <Col>Last income:</Col>
            <Col>${lastIncome}</Col>
          </Row>
        </Col>
        <Divider dashed style={{ marginTop: 5, marginBottom: 5 }} />
      </>
    );
  };
  // -------------------------- MAIN --------------------------
  const currentUser = staffList?.find((user) => user?.id === userId);
  const title = `Input income by ${currentUser?.firstName} ${currentUser?.lastName} `;
  return (
    <Modal
      title={title}
      open={open}
      onCancel={handleCancel}
      footer={false}
      afterClose={handleAfterClose}
      zIndex={9999}
    >
      <Row gutter={[20, 20]}>
        {renderExtra()}
        <IncomeStaffJobId record={record} />
        <IncomeStaffTime record={record} />
        <IncomeStaffServiceList record={record} />
        <IncomeStaffTotal record={record} />
        <IncomeStaffRemaining record={record} max={max} />
        <IncomeStaffInput max={max} value={value} setValue={setValue} />
        <Divider dashed style={{ marginTop: 5, marginBottom: 5 }} />
        <IncomeStaffIncomeList record={record} userList={userList} />
        {renderButtonGroup()}
      </Row>
    </Modal>
  );
};
export default DialogIncomeStaffInput;
